export class CaseStatusTriggerModel {
    public id: number;
    public newInvoice: number; // A new invoice is created.
    public outStandingInvoice: number; // All outstanding invoices for a case are paid in full.
    public piAssignedToCase: number; // The primary investigator is assigned to a case.
    public piConfiredAssignedToCase: number; // The primary investigator has confirmed their assignment to a case.
}
